import { render, staticRenderFns } from "./Excel.vue?vue&type=template&id=023f1e37&"
import script from "./Excel.vue?vue&type=script&lang=js&"
export * from "./Excel.vue?vue&type=script&lang=js&"
import style0 from "./Excel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports